



























































































import Vue from "vue";
import moment from "moment";

import permission, { PermissionName } from "@/common/mixins/permission";
import pagination, { PaginationForm } from "@/common/mixins/pagination";
import dialog from "@/common/mixins/dialog";
import { OrderBridgeSystem, TrackingNumber } from "../models/OrderBridgeSystem";
import BridgeSystemDatePickers from "../components/BridgeSystemDatePickers.vue";
import { ApprovalStatus } from "../models/ApprovalStatus";
import { Shop } from "@/features/shop/models/Shop";

export default Vue.extend({
  components: { BridgeSystemDatePickers },
  mixins: [pagination, permission, dialog],
  data() {
    const successOrders: OrderBridgeSystem[] = [];
    const searchText = "";
    const shopId = 0;
    const shopInfo: Shop[] = [];
    const fromDate = moment()
      .add(-30, "days")
      .format("YYYY-MM-DD");
    const toDate = moment(new Date()).format("YYYY-MM-DD");
    const maxDate = moment(new Date()).format("YYYY-MM-DD");

    return {
      successOrders,
      searchText,
      shopId,
      shopInfo,
      fromDate,
      toDate,
      maxDate
    };
  },
  computed: {
    hasPromotionCreatePermission() {
      return (this as any).hasPermission(PermissionName.API_BRIDGE_ACTION);
    }
  },
  async created() {
    (this as any).getPaginationRouteQuery();
    await Promise.all([this.getSuccessOrders(), this.getShop()]);
  },
  watch: {
    async "$route.query"() {
      await this.getSuccessOrders();
      await this.getShop();
    }
  },
  methods: {
    async getSuccessOrders() {
      const form: PaginationForm = {
        page: (this as any).currentPage,
        perPage: (this as any).perPage
      };
      const fromDate = moment(this.fromDate)
        .startOf("days")
        .format();
      const toDate = moment(this.toDate)
        .endOf("days")
        .format();

      try {
        const {
          data,
          meta
        } = await (this as any).$dep.bridgeSystemUseCase.getOrders(
          form,
          ApprovalStatus.SUCCESS,
          fromDate,
          toDate,
          this.searchText,
          this.shopId,
          "approveDate",
          "DESC"
        );
        this.successOrders = data;
        (this as any).setPaginationMeta(meta);
        (this as any).setSearchQuery(this.searchText);
      } catch (error) {
        console.log(error.response);
      }
    },
    async getShop() {
      try {
        const { data } = await (this as any).$dep.bridgeSystemUseCase.getShop();
        this.shopInfo = data;
      } catch (error) {
        console.log(error);
      }
    },
    async getByShop() {
      this.getSuccessOrders();
    },
    mapTrackingNumber(value: TrackingNumber[]) {
      const trackingNumbers = value.map(item => item.trackingNumber);
      return trackingNumbers.join(",");
    },
    async searchOrders() {
      (this as any).setPaginationMeta({
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 10
      });
      this.getSuccessOrders();
    },
    setFromDate(date: string, notFetch = false) {
      this.fromDate = date;
      if (!notFetch) {
        this.getSuccessOrders();
      }
    },
    setToDate(date: string, notFetch = false) {
      this.toDate = date;
      if (!notFetch) {
        this.getSuccessOrders();
      }
    }
  }
});
